import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { RewardUnlockStrategy } from '@brandclub/types';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import CloseIcon from '@mui/icons-material/Close';
import { styled, useTheme, Icon, Backdrop } from '@mui/material';
import React, { useEffect } from 'react';
import { OutOfStockPill } from '../../BrandclubLanding/components/OutOfStockPill/OutOfStockPill.js';
import { RewardPillWithText } from '../../BrandclubLanding/components/RewardPill/RewardPillWithText.js';
import { CampaignType } from '../../types/Campaign.js';
import '../../types/filters.js';
import '../../types/product.js';
import '../../types/RewardAmountType.js';
import '../../analytics/events.js';
import 'uuid';
import 'lodash/includes';
import { getEntityImage } from '../../utils/assetUtils.js';
import '../../utils/brandclubStoreConfigUtils.js';
import 'numeral';
import { formatMoney, isShopifyProduct, getRetailerFromId } from '../../utils/stringUtils.js';
import '../../utils/broadcast.js';
import { getBuyOrViewProductMetaTag } from '../../utils/dataLayer.js';
import { TABLET_SCREEN_SIZE } from '../../utils/constants/Constants.js';
import 'awesome-phonenumber';
import 'lodash/isEqual';
import 'lodash/get';
import 'lodash/orderBy';
import '@splitsoftware/splitio-react';
import { isProductEligibleForCheckout, getAddToBagText, getPurchaseRewardAmountForProduct, isProductOutOfStock } from '../../utils/productUtils.js';
import '../../api/graphQl/brand.js';
import '../../api/graphQl/product.js';
import '../../api/cache/appConfigQueryOptions.js';
import 'lodash/omitBy';
import 'lodash/isNil';
import '../../utils/logger.js';
import '../../icons/abstract/AbstractArcIcon.js';
import '../../icons/AddCircleIcon.js';
import '../../icons/AddCircleOutlineIcon.js';
import '../../icons/ArrowCircleRightIcon.js';
import '../../icons/ArrowLeftIcon.js';
import '../../icons/ArrowRightIcon.js';
import '../../icons/BoltIcon.js';
import '../../icons/BookmarkStarIcon.js';
import '../../icons/CalendarIcon.js';
import '../../icons/CancelIcon.js';
import '../../icons/ChatIcon.js';
import '../../icons/CheckCircleIcon.js';
import '../../icons/CheckMarkIcon.js';
import '../../icons/ChevronDownIcon.js';
import '../../icons/ChevronLeftIcon.js';
import '../../icons/ChevronRightIcon.js';
import '../../icons/ChevronUpIcon.js';
import '../../icons/CloseIcon.js';
import '../../icons/MenuIcon.js';
import '../../icons/NotificationActiveIcon.js';
import '../../icons/PaperPlaneIcon.js';
import '../../icons/PendingIcon.js';
import '../../icons/PersonIcon.js';
import '../../icons/PlayCircleIcon.js';
import '../../icons/RemoveCircleIcon.js';
import '../../icons/SearchIcon.js';
import '../../icons/SellIcon.js';
import '../../icons/ShoppingBagIcon.js';
import '../../icons/SmartphoneIcon.js';
import '../../icons/StarIcon.js';
import '../../icons/StarOutlineIcon.js';
import '../../icons/SuccessCheckCircleIcon.js';
import '../../icons/TuneIcon.js';
import '../../icons/FourPointStarIcon.js';
import { Button } from '../Button/Button.js';
import '../Button/CustomDtcBagButton.js';
import { BuyBoxType } from './BuyBoxType.js';

const ProductPriceList = ({ products, onBuyClick, onOpenRetailerProductPageClick, onExpandBuyBoxToggle, isExpanded, checkoutAllowedOfferType, disabledCheckout, zeroPadding, }) => {
    const theme = useTheme();
    const removeNonLiveCampaigns = (campaign) => {
        return campaign.filter((c) => c.campaignStatus === 'live');
    };
    return (React.createElement(Details, { zeroPadding: zeroPadding },
        React.createElement("div", { className: "product_price", style: isExpanded && !zeroPadding ? { padding: '15px 0 15px', gap: 20 } : {} },
            (theme === null || theme === void 0 ? void 0 : theme.dtcMode) && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "detail_title" }, "Ways to buy"))),
            products.map((item, idx) => {
                var _a;
                let hasActiveInstantReward = false;
                for (const campaignReward of removeNonLiveCampaigns((_a = item === null || item === void 0 ? void 0 : item.campaignRewards) !== null && _a !== void 0 ? _a : [])) {
                    if ((campaignReward === null || campaignReward === void 0 ? void 0 : campaignReward.campaignType) === CampaignType.DailyDealsRewardCampaign ||
                        (campaignReward === null || campaignReward === void 0 ? void 0 : campaignReward.rewardUnlockStrategy) === RewardUnlockStrategy.Instant) {
                        hasActiveInstantReward = true;
                        break;
                    }
                }
                const rewardAmount = getPurchaseRewardAmountForProduct(item);
                const rewardPercent = !!item.retailPrice && !!rewardAmount ? (rewardAmount * 100) / item.retailPrice : 0;
                const shopifyProduct = isShopifyProduct(item === null || item === void 0 ? void 0 : item.retailerId);
                const isOutOfStock = isProductOutOfStock(item, checkoutAllowedOfferType);
                return (React.createElement("div", { key: idx, className: "price_card" },
                    React.createElement("div", { className: "retailer_icon", onClick: () => {
                            onExpandBuyBoxToggle === null || onExpandBuyBoxToggle === void 0 ? void 0 : onExpandBuyBoxToggle();
                        } },
                        React.createElement("img", { alt: "retailer", src: getEntityImage(item.retailerId, 'retailer') })),
                    React.createElement("div", { style: { flex: 1 } },
                        React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between' } },
                            React.createElement("div", { className: "detail_retailer_price" },
                                React.createElement("a", { href: item.retailerProductPageUrl, target: "_blank", onClick: (e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        onOpenRetailerProductPageClick(item);
                                    }, style: { textDecoration: 'none', color: theme.vars.palette.text.primary } },
                                    React.createElement("div", { className: "name", style: {} }, item.retailerDisplayName || getRetailerFromId(item.retailerId) || '')),
                                React.createElement("div", { className: "price" }, formatMoney(item.retailPrice))),
                            isOutOfStock && shopifyProduct ? null : (React.createElement(Button, Object.assign({ increaseSpecificity: true, variant: "solid", color: "primary", height: { xs: 32, md: 35 }, sx: {
                                    minWidth: 82,
                                    width: 'fit-content',
                                    margin: '10px 0',
                                    [`@media screen and (max-width: 400px)`]: {
                                        maxWidth: 200,
                                    },
                                }, className: "bc-dialog-buy-button" }, getBuyOrViewProductMetaTag(isProductEligibleForCheckout(item, checkoutAllowedOfferType) && !disabledCheckout
                                ? 'buy'
                                : 'view', item.retailerDisplayName || getRetailerFromId(item.retailerId) || '', item.name, item.id, item.stacklineSku, window.location.href, item.retailPrice), { onClick: (e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if (isProductEligibleForCheckout(item, checkoutAllowedOfferType) && !disabledCheckout) {
                                        onBuyClick(item);
                                    }
                                    else {
                                        onOpenRetailerProductPageClick(item);
                                    }
                                } }), getAddToBagText(item, checkoutAllowedOfferType, disabledCheckout)))),
                        isOutOfStock ? React.createElement(OutOfStockPill, { pillContainerStyle: {} }) : null,
                        rewardAmount && !isOutOfStock ? (React.createElement(RewardPillWithText, { pillContainerStyle: isExpanded ? { padding: '1px 6.5px', fontSize: 11 } : {}, rewardAmount: rewardAmount, rewardPercent: rewardPercent, rewardCampaignType: hasActiveInstantReward
                                ? CampaignType.DailyDealsRewardCampaign
                                : CampaignType.PurchaseRewardCampaign })) : null)));
            }))));
};
const ProductPrice = (_a) => {
    var { productsToList, onOpenRetailerProductPageClick, onBuyClick, buyBoxType, onExpandBuyBoxToggle: _onExpandBuyBoxToggle, checkoutAllowedOfferType, disabledCheckout, zeroPadding } = _a, props = __rest(_a, ["productsToList", "onOpenRetailerProductPageClick", "onBuyClick", "buyBoxType", "onExpandBuyBoxToggle", "checkoutAllowedOfferType", "disabledCheckout", "zeroPadding"]);
    const theme = useTheme();
    if (!(productsToList === null || productsToList === void 0 ? void 0 : productsToList.length)) {
        return null;
    }
    const showStickyBuyBox = buyBoxType === BuyBoxType.BuyBoxBottomSheetShort ||
        buyBoxType === BuyBoxType.BuyBoxBottomSheetExpanded ||
        buyBoxType === BuyBoxType.BuyBoxBottomSheetAlwaysExpanded;
    const hideBackdrop = buyBoxType === BuyBoxType.BuyBoxBottomSheetAlwaysExpandedWithoutBackdrop;
    const canExpand = (productsToList === null || productsToList === void 0 ? void 0 : productsToList.length) > 1 && buyBoxType === BuyBoxType.BuyBoxBottomSheetShort;
    const isExpanded = buyBoxType === BuyBoxType.BuyBoxBottomSheetExpanded ||
        buyBoxType === BuyBoxType.BuyBoxBottomSheetAlwaysExpanded ||
        buyBoxType === BuyBoxType.BuyBoxBottomSheetAlwaysExpandedWithoutBackdrop;
    const fixedPosition = props.fixedPosition || buyBoxType === BuyBoxType.BuyBoxBottomSheetExpanded;
    const onExpandBuyBoxToggle = () => {
        if (canExpand || isExpanded) {
            _onExpandBuyBoxToggle === null || _onExpandBuyBoxToggle === void 0 ? void 0 : _onExpandBuyBoxToggle();
        }
    };
    useEffect(() => {
        const overflow = document.body.style.overflow;
        if (isExpanded) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = overflow;
        }
        return () => {
            document.body.style.overflow = overflow;
        };
    }, [isExpanded]);
    if (showStickyBuyBox) {
        return (React.createElement(FixedToBottomDetails, { hideBackdrop: hideBackdrop, isExpanded: isExpanded, fixedPosition: fixedPosition, expandToggle: onExpandBuyBoxToggle }, isExpanded ? (React.createElement(ProductPriceList, { products: productsToList, onBuyClick: onBuyClick, onOpenRetailerProductPageClick: onOpenRetailerProductPageClick, onExpandBuyBoxToggle: onExpandBuyBoxToggle, isExpanded: isExpanded, checkoutAllowedOfferType: checkoutAllowedOfferType, disabledCheckout: disabledCheckout, zeroPadding: zeroPadding })) : (React.createElement(Details, { zeroPadding: zeroPadding },
            React.createElement("div", { className: "product_price", style: { padding: 0, paddingBottom: 5 } }, [productsToList[0]].map((item, idx) => {
                var _a;
                let hasActiveInstantReward = item.hasActiveInstantReward;
                for (const campaignReward of ((_a = item === null || item === void 0 ? void 0 : item.campaignRewards) !== null && _a !== void 0 ? _a : []).filter((c) => c.campaignStatus === 'live')) {
                    if ((campaignReward === null || campaignReward === void 0 ? void 0 : campaignReward.campaignType) === CampaignType.DailyDealsRewardCampaign ||
                        (campaignReward === null || campaignReward === void 0 ? void 0 : campaignReward.rewardUnlockStrategy) === RewardUnlockStrategy.Instant) {
                        hasActiveInstantReward = true;
                        break;
                    }
                }
                const rewardPercent = !!item.retailPrice && !!(item === null || item === void 0 ? void 0 : item.totalRewardAmount)
                    ? (item.totalRewardAmount * 100) / item.retailPrice
                    : 0;
                return (React.createElement("div", { key: idx, className: "price_card", style: { flexDirection: 'column', alignItems: 'center' } },
                    React.createElement("div", { style: { display: 'flex', width: '100%' } },
                        React.createElement("div", { style: { marginRight: 7 }, className: "retailer_icon", onClick: () => {
                                onExpandBuyBoxToggle === null || onExpandBuyBoxToggle === void 0 ? void 0 : onExpandBuyBoxToggle();
                            } },
                            React.createElement("img", { alt: "retailer", src: getEntityImage(item.retailerId, 'retailer') })),
                        React.createElement("div", { style: { flex: 1 } },
                            React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
                                canExpand ? (React.createElement(ArrowBackIosNewIcon, { style: { transform: 'rotate(90deg) scale(0.5)' }, onClick: () => {
                                        onExpandBuyBoxToggle === null || onExpandBuyBoxToggle === void 0 ? void 0 : onExpandBuyBoxToggle();
                                    } })) : null,
                                React.createElement(Button, { height: { md: 44 }, disableMaxWidth: true, fullWidth: true, sx: {
                                        backgroundColor: theme.vars.palette.primary.main,
                                        fontWeight: 600,
                                        margin: '5px 0 10px 10px',
                                    }, onClick: (e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        if (isProductEligibleForCheckout(item, checkoutAllowedOfferType) && !disabledCheckout) {
                                            onBuyClick(item);
                                        }
                                        else {
                                            onOpenRetailerProductPageClick(item);
                                        }
                                    } }, `${getAddToBagText(item, checkoutAllowedOfferType, disabledCheckout)}` +
                                    (item.retailPrice !== undefined ? '  \u2022  ' + formatMoney(item.retailPrice) : ''))))),
                    (item === null || item === void 0 ? void 0 : item.totalRewardAmount) ? (React.createElement(RewardPillWithText, { containerStyle: { marginLeft: 19 }, rewardAmount: item.totalRewardAmount, rewardPercent: rewardPercent, pillContainerStyle: isExpanded ? { height: 22, width: '60px' } : {}, rewardCampaignType: hasActiveInstantReward
                            ? CampaignType.DailyDealsRewardCampaign
                            : CampaignType.PurchaseRewardCampaign })) : null));
            }))))));
    }
    return (React.createElement(ProductPriceList, { products: productsToList, onBuyClick: onBuyClick, onOpenRetailerProductPageClick: onOpenRetailerProductPageClick, onExpandBuyBoxToggle: onExpandBuyBoxToggle, isExpanded: isExpanded, checkoutAllowedOfferType: checkoutAllowedOfferType, zeroPadding: zeroPadding }));
};
const Details = styled('div', {
    label: 'ProductPriceDetails',
    shouldForwardProp: (prop) => prop !== 'zeroPadding',
})(({ theme, zeroPadding }) => ({
    '.product_price': {
        padding: zeroPadding ? '0' : '40px 35px',
        [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
            padding: zeroPadding ? '0' : '40px 0px',
            paddingTop: zeroPadding ? '0' : 0,
            width: '100%',
        },
        display: 'flex',
        flexDirection: 'column',
        gap: zeroPadding ? 18 : 30,
        '.bar': {
            display: 'block !important',
            width: '31px !important',
            height: '4px !important',
            borderRadius: '10px !important',
            backgroundColor: '#d8d8d8 !important',
            margin: '0 auto -2.5px',
            marginTop: '-8px',
        },
        '.detail_title': {
            color: theme.vars.palette.text.primary,
            margin: 'unset',
            fontSize: '22px !important',
            fontWeight: '600 !important ',
            textAlign: 'center !important',
        },
        '.price_card': {
            display: 'flex',
            '.retailer_icon': {
                width: '50px',
                height: '50px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '20px',
                marginTop: '5px',
                img: {
                    maxWidth: '100%',
                    maxHeight: '100%',
                },
            },
            '.detail_retailer_price': {
                flex: 1,
                marginBottom: 5,
                div: {
                    width: 'fit-content',
                },
                '.name': {
                    fontSize: 14,
                    fontWeight: 600,
                },
                '.price': {
                    fontSize: 24,
                    fontWeight: 600,
                    color: theme.vars.palette.text.primary,
                    [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
                        fontSize: 22,
                    },
                },
            },
        },
    },
}));
const FixedToBottomDetails = ({ children, isExpanded, expandToggle, hideBackdrop, fixedPosition, }) => {
    const theme = useTheme();
    const FixedComponent = ({ children: ch }) => (React.createElement(React.Fragment, null,
        hideBackdrop ? null : (React.createElement(Backdrop, { open: isExpanded, onClick: () => {
                expandToggle === null || expandToggle === void 0 ? void 0 : expandToggle();
            } })),
        React.createElement("div", { style: {
                position: fixedPosition ? 'fixed' : 'relative',
                zIndex: 901,
                width: '100%',
                padding: '10px 20px 18px 20px',
                bottom: 0,
                left: 0,
                background: theme.vars.palette.background.paper,
                borderTop: `1px solid ${theme.vars.palette.divider}`,
                boxSizing: 'border-box',
                minHeight: 121,
                transition: 'all 0.3s ease-in-out',
                borderTopLeftRadius: isExpanded ? 20 : 0,
                borderTopRightRadius: isExpanded ? 20 : 0,
            } }, ch)));
    return isExpanded && !(theme === null || theme === void 0 ? void 0 : theme.dtcMode) ? (React.createElement(FixedComponent, null,
        React.createElement(React.Fragment, null,
            React.createElement(Icon, { sx: (theme) => ({
                    paddingTop: 0,
                    float: 'right',
                    cursor: 'pointer',
                    color: theme.vars.palette.text.primary,
                }), className: "close", onClick: () => {
                    expandToggle === null || expandToggle === void 0 ? void 0 : expandToggle();
                } },
                React.createElement(CloseIcon, null)),
            children))) : (React.createElement(FixedComponent, null,
        " ",
        children,
        " "));
};

export { ProductPrice };
//# sourceMappingURL=ProductPrice.js.map
